import { useTranslation } from 'react-i18next';
import { Modal } from '../Modal';
import { Button } from 'shared/components/Button';
import { ConstellationDivider } from 'shared/components/ConstellationDivider';

export interface SubmitLoreModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SubmitLoreModal({ isOpen, onClose }: SubmitLoreModalProps) {
  const { t } = useTranslation('community');

  return (
    <Modal isOpen={isOpen} onClose={onClose} titleId="modal-title">
      <div className="mb-8 pr-8">
        <h2 id="modal-title" className="font-serif text-4xl text-on-surface mb-2">{t('submitLoreModal.title')}</h2>
        <p className="text-on-surface-variant italic font-light">
          {t('submitLoreModal.subtitle')}
        </p>
      </div>

      <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label htmlFor="lore-name" className="font-sans text-xs uppercase tracking-widest text-tertiary-fixed-dim">
              {t('submitLoreModal.nameLabel')}
            </label>
            <input
              id="lore-name"
              type="text"
              placeholder={t('submitLoreModal.namePlaceholder')}
              className="w-full bg-surface-container-high border-none rounded-lg p-4 text-on-surface placeholder:text-outline/50 focus:ring-1 focus:ring-tertiary/50 transition-all"
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="lore-email" className="font-sans text-xs uppercase tracking-widest text-tertiary-fixed-dim">
              {t('submitLoreModal.emailLabel')}
            </label>
            <input
              id="lore-email"
              type="email"
              placeholder={t('submitLoreModal.emailPlaceholder')}
              className="w-full bg-surface-container-high border-none rounded-lg p-4 text-on-surface placeholder:text-outline/50 focus:ring-1 focus:ring-tertiary/50 transition-all"
            />
          </div>
        </div>

        <div className="space-y-2">
          <label htmlFor="lore-story" className="font-sans text-xs uppercase tracking-widest text-tertiary-fixed-dim">
            {t('submitLoreModal.storyLabel')}
          </label>
          <textarea
            id="lore-story"
            rows={6}
            placeholder={t('submitLoreModal.storyPlaceholder')}
            className="w-full bg-surface-container-high border-none rounded-lg p-4 text-on-surface placeholder:text-outline/50 focus:ring-1 focus:ring-tertiary/50 transition-all resize-none"
          />
        </div>

        <ConstellationDivider className="justify-center py-4 opacity-30" />

        <div className="flex flex-col md:flex-row justify-end items-center gap-6 pt-4">
          <Button
            variant="link"
            type="button"
            onClick={onClose}
            className="order-2 md:order-1 text-on-surface-variant hover:text-on-surface uppercase tracking-widest"
          >
            {t('submitLoreModal.cancel')}
          </Button>
          <Button variant="gold" size="lg" type="submit" icon="sparkle" iconPosition="right" className="order-1 md:order-2">
            {t('submitLoreModal.submit')}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
